/*
 * Calls a given callback when an object property changes.
 *
 * ```
 * observe(obj, ['property_a', 'property_b'], callback_fn)
 * ```
 * The callback function will receive the set value, key pair.
*/
function observe(o, props, f, enumerable) {
	var enumerable = enumerable === undefined ? true : enumerable;
	if (typeof(props) != 'Array') {
		props = [props];
	}
	props.forEach(function(p) {
		var innerValue = o[p];
		Object.defineProperty(o, p, {
			set: function(v) {
				innerValue = v;
				f(innerValue, p);
			},
			get: function() {
				return innerValue;
			},
			enumerable: enumerable
		});
	});
};

export default observe;